export interface RemoteClient {
    Id: string;
    ClientInfo: string;
    ClientId: string;
    Enabled: boolean;
    Locked: boolean;
}

export interface RemoteClients {
    ClaimedSlots: RemoteClient[];
    MaxSlots: number;
    SlotsRange?: number[];
}

export const SlotsRange = (r: RemoteClients): number[] => {
    const res = [];
    const start = r.ClaimedSlots.length > 0 ? r.ClaimedSlots.length : 1;
    for (let i = start; i <= 5; i++) {
        res.push(i);
    }
    return res;
};
